import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { getAuthClient } from "@tudigo-monorepo/core-tudigo-api";
import useAuthStore from "@tudigo-monorepo/web-tudigo-auth-store";
import {
  HelperButton,
  useIsHelperVisible,
} from "@tudigo-monorepo/web-tudigo-helper";
import { useAnalytics } from "@tudigo-monorepo/web-tudigo-tracking";

export function ProtectedRoute() {
  const accessToken = useAuthStore((state) => state.accessToken);
  const location = useLocation();
  const isHelperVisible = useIsHelperVisible();
  const { track } = useAnalytics();
  const authClient = getAuthClient();
  const authUrl = authClient.authorizeUrl();

  useEffect(() => {
    if (accessToken) {
      const pageName = location.pathname;
      const pageUrl = `${window.location.origin}${location.pathname}${location.search}`;

      track("ui.page.view", {
        page_name: pageName,
        page_url: pageUrl,
      });
    }
  }, [accessToken, location.pathname, location.search, track]);

  if (!accessToken) {
    localStorage.setItem(
      "target-url",
      `${location.pathname}${location.search}`,
    );
    window.location.replace(authUrl);
  }

  return (
    accessToken && (
      <>
        <Outlet />
        {isHelperVisible && <HelperButton />}
      </>
    )
  );
}
